export const ROLES_ID = {
  2: 'Admin',
  3: 'Supervisor',
  4: 'User',
  5: 'Annotator',
  6: 'Reviewer',
};

export const ROLES_NAMES = {
  ADMIN: 2,
  SUPERVISOR: 3,
  USER: 4,
  ANNOTATOR: 5,
  REVIEWER: 6,
};

export const ROLE_BASED_MENUS = {
  [ROLES_NAMES.ADMIN]: ['dashboard', 'reports', 'users', 'ai-damage-detection'],
  [ROLES_NAMES.SUPERVISOR]: ['dashboard', 'reports'],
  [ROLES_NAMES.USER]: ['dashboard'],
  [ROLES_NAMES.ANNOTATOR]: ['dashboard'],
  [ROLES_NAMES.REVIEWER]: ['dashboard'],
};

const VIDEO_EXTENSIONS_PATTERN = /\.(mp4|mov|webm|ogg|m4v)(\?.*)?$/i;
const THUMBNAIL_EXTENSIONS = ['jpg', 'jpeg', 'png', 'webp'] as const;
const DIRECT_VIDEO_PREVIEW = 'onpremise';

const normalizeApiUrl = (url?: string) => url?.replace(/\/$/, '') ?? '';

export const shouldUseDirectVideoPreview = (): boolean =>
  normalizeApiUrl(process.env.REACT_APP_PLATFORM) === DIRECT_VIDEO_PREVIEW;

export const buildVideoThumbnailCandidates = (src: string): string[] => {
  if (shouldUseDirectVideoPreview()) {
    return [src];
  }
  if (!src) return [];

  const [path, query = ''] = src.split('?');
  if (!VIDEO_EXTENSIONS_PATTERN.test(path)) {
    return [src];
  }

  const basePath = path.replace(/\.[^/.]+$/i, '');
  const querySuffix = query ? `?${query}` : '';

  return THUMBNAIL_EXTENSIONS.map(extension => `${basePath}.${extension}${querySuffix}`);
};
